<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import axios from "@/plugins/axios.js";

const route = useRoute();
const router = useRouter();
const store = useStore();

const idxLeSiteMain = store.getters.getIdxLeSiteMain;
// Toss 리다이렉트 시 URL 쿼리(idxLeSugangPayInfo)가 유실될 수 있으므로 세션 저장값을 폴백으로 사용한다.
const idxLeSugangPayInfo =
  route.query.idxLeSugangPayInfo ||
  JSON.parse(sessionStorage.getItem("lifeeduPaymentInfo") || "{}").idxLeSugangPayInfo;

const regDatailInfo = ref({
  regDateInfoList: {},
});

const confirmPayment = async () => {
  const { paymentKey, orderId } = route.query;
  console.log("[결제] (모바일) 결제 승인 콜백 진입", {
    hasPaymentKey: !!paymentKey,
    hasOrderId: !!orderId,
  });

  if (paymentKey && orderId) {
    const savedData = JSON.parse(sessionStorage.getItem("lifeeduPaymentInfo") || "{}");
    console.log("[결제] (모바일) 세션 결제정보 조회", {
      hasSavedData: !!savedData.orderId,
      orderIdMatch: savedData.orderId === orderId,
    });

    if (!savedData.orderId || !savedData.totalPay) {
      // 승인 성공 시 세션을 비우므로(아래 78줄), 승인 완료 후 새로고침하면 여기로 온다.
      // 이 경우 재승인하지 말고 신청 내역 조회로 결과 화면을 그대로 보여준다.
      console.warn("[결제] (모바일) 세션 결제정보 없음 - 재승인 생략, 신청 내역 조회");
      await getRegisterDetail();
      return;
    }

    try {
      const params = {
        idxLeSugangPayInfo: savedData.idxLeSugangPayInfo,
        userIdx: savedData.userIdx,
        paymentKey,
        orderId,
        payWay: "C",

        // ✅ 금액은 서버 기준만 사용
        totalPay: savedData.totalPay,

        memberEmail: savedData.memberEmail,
        memberName: savedData.memberName,
        memberEname: savedData.memberEname,
        memberMobile: savedData.memberMobile,
        memberPostCode: savedData.memberPostCode,
        memberAddress: savedData.memberAddress,
        memberAddressSub: savedData.memberAddressSub,

        bookMemberName: savedData.bookMemberName,
        bookMemberMobile: savedData.bookMemberMobile,
        bookMemberPostCode: savedData.bookMemberPostCode,
        bookMemberAddress: savedData.bookMemberAddress,
        bookMemberAddressSub: savedData.bookMemberAddressSub,

        supDocument: savedData.supDocument,
      };

      console.log("[결제] (모바일) pay/confirm 요청 - 최종 승인 시도", { orderId });
      const res = await axios.post("/user/sugang/pay/confirm", params);

      if (res.data.success) {
        console.log("[결제] (모바일) pay/confirm 성공 - 결제 완료, 세션 정리");
        sessionStorage.removeItem("lifeeduPaymentInfo");
      } else {
        console.warn("[결제] (모바일) pay/confirm 실패:", res.data.message);
        // 이미 결제 처리된 건이면 재시도 화면으로 보내지 말고 결과 화면을 그대로 보여준다.
        if (res.data.message?.includes("이미 결제")) {
          sessionStorage.removeItem("lifeeduPaymentInfo");
          alert("이미 결제가 완료된 신청입니다.");
          await getRegisterDetail();
          return;
        }
        alert(res.data.message);
        router.push({
          path: "/enrolment/checkDetail",
          query: { idxLeSugangPayInfo },
        });
        return;
      }
    } catch (err) {
      console.error("[결제] (모바일) pay/confirm 처리 중 에러:", err?.response?.data?.message || err?.message || err);
      console.error(err);
      alert("결제 승인에 실패했습니다.");
      router.push({
        path: "/enrolment/checkDetail",
        query: { idxLeSugangPayInfo },
      });
      return;
    }
  }

  await getRegisterDetail();
};

const getRegisterDetail = async () => {
  try {
    const params = { idxLeSugangPayInfo };
    const res = await axios.get("/user/sugang/class/registerDetail", { params });
    if (res.data.success) {
      regDatailInfo.value = {
        regDateInfoList: res.data.data || {},
      };
    } else {
      alert(res.data.message);
    }
  } catch (e) {
    alert("신청 정보를 불러오지 못했습니다.");
  }
};

const goToMain = () => {
  router.push({
    path: "/home",
  });
};

onMounted(() => {
  confirmPayment();
});
</script>

<template>
  <div class="pt-[55px] pb-[70px] pc:py-[140px] pc-con-wrapper1">
    <p class="text-xl font-bold text-center text-orange-500 mb-7 pc:text-4xl pc:mb-11">
      수강 신청이 정상적으로<br class="pc:hidden" />
      완료되었습니다.
    </p>
    <ul class="flex flex-col gap-14 pc:gap-36 mb-14 pc:mb-24">
      <li>
        <p class="mb-5 text-lg font-bold pc:text-2xl pc:mb-4">회원 정보</p>
        <ul class="grid grid-cols-1 border-t border-b border-solid divide-y border-neutral-950 divide-solid divide-neutral-200">
          <!-- 1:1 -->
          <li v-if="regDatailInfo.regDateInfoList.sugangLecType === '1:1'" class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">회원 이름</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.memberName }}
              </p>
            </div>
          </li>

          <!-- 그룹 -->
          <li v-else class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">회원 이름(실명)</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.memberName }}
              </p>
            </div>
          </li>
          <li class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">영어이름<br class="pc:hidden" />(수업이름)</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.memberEname }}
              </p>
            </div>
          </li>
          <li class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">휴대전화</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.memberMobile }}
              </p>
            </div>
          </li>
          <li class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">주소</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.memberPostCode }}<br />{{ regDatailInfo.regDateInfoList.memberAddress }}
                {{ regDatailInfo.regDateInfoList.memberAddressSub }}
              </p>
            </div>
          </li>
        </ul>
      </li>
      <li>
        <p class="mb-5 text-lg font-bold pc:text-2xl pc:mb-4">수강 정보</p>
        <ul class="grid grid-cols-1 border-t border-b border-solid divide-y border-neutral-950 divide-solid divide-neutral-200">
          <!-- 1:1 -->
          <li v-if="regDatailInfo.regDateInfoList.sugangLecType === '1:1'" class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">수업 스케줄</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.sugangAdult }}
                과정 /
                {{ regDatailInfo.regDateInfoList.sugangLecType }}
              </p>
            </div>
          </li>

          <!-- 그룹 -->
          <li v-else class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">수업 스케줄</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.sugangAdult }}
                과정 /
                {{ regDatailInfo.regDateInfoList.sugangType }}
              </p>
            </div>
          </li>

          <!-- 1:1 -->
          <li v-if="regDatailInfo.regDateInfoList.sugangLecType === '1:1'" class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">수업 유형</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.sugangType }}
              </p>
            </div>
          </li>

          <!-- 그룹 -->
          <li v-else class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">그룹</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.sugangLecType }}
              </p>
            </div>
          </li>
          <li class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">언어</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.sugangLang }}
              </p>
            </div>
          </li>
          <li class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">수업 기간/횟수</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p
                v-if="regDatailInfo.regDateInfoList.sugangClassMonth === 0"
                class="text-sm font-medium pc:text-lg text-neutral-500"
              >
                주{{ regDatailInfo.regDateInfoList.sugangNumberOfClass }} 회
                {{ regDatailInfo.regDateInfoList.sugangLessonTime }}분
              </p>

              <p v-else class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.sugangClassMonth }}개월 주{{
                  regDatailInfo.regDateInfoList.sugangNumberOfClass
                }}
                회 {{ regDatailInfo.regDateInfoList.sugangLessonTime }}분
              </p>
            </div>
          </li>
          <li class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">레벨</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.sugangLevel }}
              </p>
            </div>
          </li>
          <li class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">수업</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.sugangClassName }}
              </p>
            </div>
          </li>

          <!-- 1:1 -->
          <li v-if="regDatailInfo.regDateInfoList.sugangLecType === '1:1'" class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">수업 횟수</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                주
                {{ regDatailInfo.regDateInfoList.sugangNumberOfClass }}회 {{ regDatailInfo.regDateInfoList.sugangLessonTime }}분
              </p>
            </div>
          </li>

          <!-- 그룹 -->
          <li v-else class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">수업시작시간</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.sugangTime }}
              </p>
            </div>
          </li>
          <li v-if="regDatailInfo.regDateInfoList.sugangLecType === '1:1'" class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">희망 수업시간</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.sugangHopeTime1 }},
                {{ regDatailInfo.regDateInfoList.sugangHopeTime2 }}
              </p>
            </div>
          </li>
          <li class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">교육비</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">{{ regDatailInfo.regDateInfoList.classPay }}원</p>
            </div>
          </li>
          <li class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">교재비</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.isBookBuy === "N" ? 0 : regDatailInfo.regDateInfoList.bookPay }}원
              </p>
            </div>
          </li>
          <li class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">총 결제금액</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">{{ regDatailInfo.regDateInfoList.totalPay }}원</p>
            </div>
          </li>
        </ul>
      </li>
      <li>
        <p class="mb-5 text-lg font-bold pc:text-2xl pc:mb-4">교재 배송지 정보</p>
        <ul class="grid grid-cols-1 border-t border-b border-solid divide-y border-neutral-950 divide-solid divide-neutral-200">
          <li class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">받는 사람</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.bookMemberName }}
              </p>
            </div>
          </li>
          <li class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">휴대전화</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.bookMemberMobile }}
              </p>
            </div>
          </li>
          <li class="flex items-center">
            <div
              class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
            >
              <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">주소</p>
            </div>
            <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
              <p class="text-sm font-medium pc:text-lg text-neutral-500">
                {{ regDatailInfo.regDateInfoList.bookMemberPostCode }}<br />{{ regDatailInfo.regDateInfoList.bookMemberAddress }}
                {{ regDatailInfo.regDateInfoList.bookMemberAddressSub }}
              </p>
            </div>
          </li>
        </ul>
      </li>
    </ul>

    <p
      class="max-w-xs py-4 mx-auto text-sm font-bold text-center text-white bg-orange-500 rounded cursor-pointer pc:py-6 pc:text-xl"
      @click="goToMain()"
    >
      메인 페이지로 이동
    </p>
  </div>
</template>
